<template>
  <div>
    <h1>Tady bude zobrazena aplikace MojaMapa...jste na dev verzi, ta aplikaci nepodporuje.</h1>
    <router-link style="font-size: 50px" :to="localeRoute('home')">HOME Link</router-link>
  </div>
</template>

<script>
export default {
  name: 'map-app'
}
</script>
